// notification content:

// under 500 sessions
export const noStatsContent = (sessionsAnalyzed) => {
  const analyzingTitle = "Almost There!";
  const analyzingMsg = "Fixel learns each site’s unique engagement patterns by analyzing at least 500 sessions.";
  const doneAnalyzingTitle = "Done collecting, now calculating!";
  const doneAnalyzingMsg = "We've finished collecting the initial 500 sessions for the analysis. The model is being calculated and will be ready over the next 24 hours.";
  return {
    title: parseInt(sessionsAnalyzed) < 500 ? analyzingTitle : doneAnalyzingTitle,
    massage: parseInt(sessionsAnalyzed) < 500 ? analyzingMsg : doneAnalyzingMsg,
    sessionsAnalyzed: sessionsAnalyzed,
  };
};

// After successful integration
export const IntegrationSuccess = (platform) => {
  return {
    title: `${platform} Integration`,
    massage: `The integration with ${platform} was completed successfully. Fixel will now sync audiences directly for you to use in campaigns.`,
    btnLabel: "Close",
  };
};
// Integration failure [warning]
// After failed integration
export const IntegrationFailure = (platform) => {
  return {
    title: `${platform} Integration`,
    massage: `The integration with ${platform} has failed. Please try again or contact the Fixel team.`,
    btnLabel: "Try again",
  };
};
// Segment active [success]
// On first entrance after the segment is set to active
export const SegmentActive = () => {
  return {
    title: `Your audiences are now active`,
    massage: `Fixel's learning phase is now over. From now on, sessions will be scored and added to the Fixel audiences in your connected ad platforms.`,
    btnLabel: "Close",
  };
};
// Trial nearing end [info]
// Trial days count is 7 or less
export const TrialNearEnd = (numOfDays) => {
  return {
    title: `Your trial is about to expire`,
    massage: `Your trial will end in ${numOfDays} days. Upgrade now to keep using Fixel's audiences in your campaigns.`,
    btnLabel: "Upgrade now",
  };
};
// Trial over [warning]
// Trial plan expired
export const TrialOver = () => {
  return {
    title: `Your trial has ended`,
    massage: `Your Fixel trial is over and new sessions will not be analyzed. Upgrade now to keep using Fixel's audiences in your campaigns.`,
    btnLabel: "Upgrade now",
  };
};
// No Active Plan [warning]
// Plan Terminated and reinstalled
export const NoPlan = () => {
  return {
    title: `Upgrade required`,
    massage: `Your account doesn't have any active plan. To use Fixel's audiences in your campaigns, please upgrade to a paid plan`,
    btnLabel: "Upgrade now",
  };
};
// Payment complete [success]
// After payment completion
export const PaymentComplete = (newPlanName) => {
  return {
    title: `Plan updated`,
    massage: `Thank you for upgrading to ${newPlanName} paid plan. You can now boost your campaigns with Fixel's audiences.`,
    btnLabel: "Close",
  };
};
// Plan downgraded to a lower plan [success]
// After plan downgrade
export const PlanDowngrade = (newPlanName) => {
  return {
    title: `Plan changed`,
    massage: `Your Fixel plan has been successfully changed to ${newPlanName}.`,
    btnLabel: "Close",
  };
};
// Plan cancellation [warning]
// After plan cancelled
export const PlanCancellation = () => {
  return {
    title: `Plan canceled`,
    massage: `Your Fixel plan has been canceled successfully. You can subscribe to any plan anytime to keep using Fixel's audiences in your campaigns.`,
    btnLabel: "Close",
  };
};
// Potential gain
// if Facebook is not integrated
export const gainContent = () => {
  return {
    title: "Scale your ads to Engaged Shoppers ",
    massage: "Based on your site's data, using Fixel’s audiences in your campaigns could have potentially driven this additional revenue to your store.",
    btnLabel: "Dismiss",
  };
};
